var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-archive"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive",
    clipPath: "url(#clip-archive)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34377",
    "data-name": "Path 34377",
    d: "M20.54,5.23,19.15,3.55A1.451,1.451,0,0,0,18,3H6a1.486,1.486,0,0,0-1.16.55L3.46,5.23A1.958,1.958,0,0,0,3,6.5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6.5A1.958,1.958,0,0,0,20.54,5.23ZM11.65,17.15,6.5,12H10V10h4v2h3.5l-5.15,5.15A.5.5,0,0,1,11.65,17.15ZM5.12,5l.81-1h12l.94,1Z",
    transform: "translate(-3 -3)",
    fill: "#9eafc2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/archived.a183acbdbcf1f79083e2b2ca60a8356a.svg";
export { ForwardRef as ReactComponent };